import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import {TbSend} from 'react-icons/tb';
import { contactData, photoBookData } from '../data';
import { motion as m } from 'framer-motion';
import { fadeIn, staggerContainer } from '../variants';

const WriteUs = () => {
  const { 
    coopi, coopi1, coopi2, 
    coopi3, coopi4, coopi5, 
    coopi6, coopi7, coopi8, 
    pretitle, sub1, title } = contactData;

  const { 
    photobtnText, photopretitle,
    photosubtitle, phototitle } = photoBookData;

  const form = useRef();
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_thxx1ia', 'template_4dgf23g', form.current, 'zirl70GOVLZ_IbSJy')
      .then((result) => {
          console.log(result.text);
          setSubmitted(true);
          alert('Message submited ✨');
      }, (error) => {
          console.log(error.text);
      });

      form.current?.reset();
  };

  return (
    <section id='write us' className='cursor-default relative bg-fixed bg-cover bg-cntbg overflow-hidden min-h-[100vh]'>
     <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-70" />
     <div className='container mx-auto my-[100px]'>
     
     <m.div 
     variants={staggerContainer}
     initial='hidden'
     whileInView={'show'}
     viewport={{once: false, amount: 0.01}}
     className='relative z-10 text-center flex flex-col lg:flex-row lg:gap-x-[50px] items-center lg:content-center my-[40px]'>
          
          <div 
          className='flex-1 lg:text-center lg:w-4/5'>
            <m.div variants={fadeIn('down', 'tween', 0.3, 1.1)} className='pretitle'>{pretitle}</m.div>
            <m.h2 variants={fadeIn('down', 'tween', 0.4, 1.1)} className='h2 capitalize text-white'>{title}</m.h2>
            <m.p variants={fadeIn('down', 'tween', 0.5, 1.1)} className='mb-10 text-white'>{sub1}</m.p>

            <m.form variants={fadeIn('up', 'tween', 0.3, 1.1)} ref={form} onSubmit={sendEmail} className='flex flex-col text-left'>
              <div className='p-8 m-5 lg:m-0 lg:w-[100%] rounded ring-1 ring-accent outline-none'>
                <m.div variants={fadeIn('right', 'spring', 0.4, 1.1)} className='pb-2'>
                  <label className='text-sm text-white'>your name</label>
                  <input 
                  className='cntinpt' 
                  type='text'
                  name='name'
                  required
                  placeholder='enter your name'
                  />
                </m.div>

                <m.div variants={fadeIn('right', 'spring', 0.5, 1.1)} className='pb-2'>
                  <label className='text-sm text-white'>your @email</label>
                  <input 
                  className='cntinpt'
                  type='email'
                  name='email'
                  required
                  placeholder='enter your email' />
                </m.div>

                <m.div variants={fadeIn('right', 'spring', 0.6, 1.1)} className='pb-2'>
                  <label className='text-sm text-white'>mobile number</label>
                  <input 
                  className='cntinpt'
                  type='tel'
                  name='mobile'
                  placeholder='mobile (optional)' />
                </m.div>

                <m.div variants={fadeIn('right', 'spring', 0.7, 1.1)} className='pb-5'>
                  <label className='text-sm text-white'>message</label>
                  <textarea 
                  className='txtare' 
                  name='message'
                  rows={4} 
                  required
                  placeholder='message' />
                </m.div>

                <m.div variants={fadeIn('right', 'spring', 0.8, 1.1)} className='pb-2'>
                  <button type='submit' className='btn w-full lg:w-1/3 flex flex-rox items-center hover:tb-send-translate'>send
                    <TbSend className="tb-send-icon ml-2" />
                  </button>
                </m.div>

              </div>
            </m.form>
          </div>

          <div id='photo book' className='flex-2 mt-1 lg:w-2/5'>
          <m.div 
          variants={fadeIn('right', 'tween', 0.2, 1.6)} 
          className='flex-1 lg:text-center'>
            <div className='pretitle'>{photopretitle}</div>
            <h2 className='h2 capitalize text-white'>{phototitle}</h2>
            <p className='mb-10 text-white'>{photosubtitle}</p>
            
          </m.div>
          
          <m.div variants={fadeIn('left', 'spring', 0.3, 1.1)} className='p-5 lg:p-0 mt-10 mx-auto gap-6 columns-3 space-y-5 hover:scale-120'>
            <img className='phtimg' src={coopi} alt=''/>
            <img className='phtimg' src={coopi1} alt=''/>
            <img className='phtimg' src={coopi2} alt=''/>
            <img className='phtimg' src={coopi3} alt=''/>
            <img className='phtimg' src={coopi4} alt=''/>
            <img className='phtimg' src={coopi5} alt=''/>
            <img className='phtimg' src={coopi6} alt=''/>
            <img className='phtimg' src={coopi7} alt=''/>
            <img className='phtimg' src={coopi8} alt=''/>
          </m.div>

          <m.div variants={fadeIn('left', 'spring', 0.4, 1.1)}>
          <a target='_blank' href="https://www.instagram.com/_bunny98_/"><button className='btn mx-auto lg:w-full lg:mx-0'>{photobtnText}</button></a>
          </m.div>

          </div>
        </m.div>

     </div>
    </section>
  );
};

export default WriteUs;
